import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";

interface IProps {
  from: { name: string; link: string };
  current: string;
}
const PageLinks = ({ from, current }: IProps) => {
  return (
    <Container>
      <TextLink to={from.link}>
        <Typography color={Colors.grey300} size={"s"} mr="0.4">
          {from.name}
        </Typography>
      </TextLink>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M5.25 4.0835L8.75 7.00016L5.25 10.2085"
          stroke="#F5F5F5"
          stroke-width="0.875"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <Typography color={Colors.grey300} size={"s"} ml="0.4">
        {current}
      </Typography>
    </Container>
  );
};

export default PageLinks;

const Container = styled.div`
  margin-bottom: 3.2rem;
  display: flex;
  align-items: center;
`;

const TextLink = styled(Link)`
  all: unset;
  cursor: pointer;
`;
